import {
  removeTimeoutBanner,
  showTimeoutBanner,
} from '../../components/AlertBanner/index.js'
import { getRelativeBasePath } from '../environments/path.js'
import {
  isLoggedIn,
  keepSSOSessionAlive,
  logOff,
} from './authentication-manager.js'

// 24 minutes before showing the banner, then 5 minutes to show the countdown in the banner, missing 1 minutes for loading
window.CTI_TIMER_IN_MINUTES_BEFORE_SHOW_BANNER = 24
window.CTI_TIMER_IN_MINUTES_TO_SHOW_COUNTDOWN_IN_BANNER = 5
let bannerTimeoutTimer = 0

// keep track of current date, the last guy to update
// this variable is the only one that matters in context of timing out
let currentSessionDate = null

export function init() {
  if (isLoggedIn()) {
    document.body &&
      document.body.addEventListener('triggerServiceCalled', () => {
        resetTimeout()
      })
    resetTimeout()
  }

  // to make debugging easier
  window.CTI_resetTimeout = resetTimeout
}

const closedClicked = () => {
  removeTimeoutBanner()
  keepSSOSessionAlive()
  resetTimeout()
}

const resetTimeout = function () {
  clearTimeout(bannerTimeoutTimer)
  currentSessionDate = new Date()
  window.localStorage.setItem('sessionTimeoutTime', currentSessionDate)
  bannerTimeoutTimer = setTimeout(handleTimeout, getTimeoutTimeToShowBanner())
}

const handleTimeout = () => {
  if (
    new Date(window.localStorage.getItem('sessionTimeoutTime')) <=
    currentSessionDate
  ) {
    showTimeoutBanner(
      window.CTI_TIMER_IN_MINUTES_TO_SHOW_COUNTDOWN_IN_BANNER,
      closedClicked,
      onTimeComplete
    )
  }
}

const onTimeComplete = () => {
  logOff()
  window.location.href = getRelativeBasePath() + '/login?timeout=true'
}

const getTimeoutTimeToShowBanner = function () {
  return window.CTI_TIMER_IN_MINUTES_BEFORE_SHOW_BANNER * 1000 * 60
}
